import React from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';

import CourseDetailsHeader from '../CourseDetailsHeader/CourseDetailsHeader';
import Discussions from '../../../components/Discussions/Discussions';

@connect(state => ({
  course: state.courseDetails.course,
}))
export default class CourseDetailsDiscussions extends React.Component {
  render() {
    return (
      <div>
        <CourseDetailsHeader />
        <Discussions
          courseId={_.get(this, 'props.course._id')}
          disableAutoload
        />
      </div>
    );
  }
}
